// extracted by mini-css-extract-plugin
export default {"scoreTag":"gxKpXLnYnzMr77EKvKgQ","pulse":"_AjxDUDwLrf0nzF7Vdgd"};